export default "__VITE_ASSET__12446e4e__"